import { motion } from "framer-motion";
import { Reveal, stagger, fadeUp } from "@/lib/motion";
import { BENEFITS } from "@/lib/site-data";

const Benefits = () => {
  return (
    <section
      data-testid="benefits-section"
      className="relative mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32"
    >
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <span className="eyebrow">Why it matters</span>
          <h2 className="mt-5 font-heading text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl">
            A strong online presence is your best salesperson
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-white/60 md:text-lg">
            Your website is often the first impression a customer has of your
            business. We make sure it builds instant trust, works flawlessly
            everywhere, and quietly turns visitors into loyal customers.
          </p>
          <div className="mt-8 flex flex-wrap gap-8">
            <div>
              <p className="font-heading text-3xl font-semibold text-gradient">2x</p>
              <p className="mt-1 text-sm text-white/50">Faster to convert</p>
            </div>
            <div>
              <p className="font-heading text-3xl font-semibold text-gradient">24/7</p>
              <p className="mt-1 text-sm text-white/50">Working for you</p>
            </div>
            <div>
              <p className="font-heading text-3xl font-semibold text-gradient">100%</p>
              <p className="mt-1 text-sm text-white/50">Custom-built</p>
            </div>
          </div>
        </Reveal>

        <motion.div
          variants={stagger(0.08)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="grid grid-cols-1 gap-4 sm:grid-cols-2"
        >
          {BENEFITS.map((b) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={b.title}
                variants={fadeUp}
                data-testid={`benefit-card-${b.title.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
                className="group surface-card rounded-2xl p-6 transition-colors duration-300 hover:border-white/20"
              >
                <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-neon-cyan transition-colors duration-300 group-hover:border-neon-cyan/40">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-white">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/55">{b.text}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;
